var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "header__search-panel search-panel search-panel_type_float",
    },
    [
      _c("div", { staticClass: "catalog-panel js-catalog-panel hidden" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "form",
        {
          staticClass: "search-panel__form",
          attrs: { action: "" },
          on: { submit: _vm.submit },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "click-outside",
                  rawName: "v-click-outside",
                  value: _vm.hideTitle,
                  expression: "hideTitle",
                },
              ],
              staticClass: "search-container",
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.stringSearch,
                    expression: "stringSearch",
                  },
                ],
                staticClass: "search-panel__input",
                attrs: {
                  value: "",
                  id: "inputSearch",
                  type: "text",
                  placeholder: "Поиск товаров",
                  name: "q",
                  autocomplete: "off",
                },
                domProps: { value: _vm.stringSearch },
                on: {
                  keyup: _vm.search,
                  focus: _vm.showTitle,
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.stringSearch = $event.target.value
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isShowSearchTitle,
                      expression: "isShowSearchTitle",
                    },
                  ],
                  staticClass: "title-search-result",
                },
                [
                  _c(
                    "div",
                    { staticClass: "search-panel__dropdown-result row" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "search-panel__block search-panel__goods",
                        },
                        [
                          _vm.found.altQuery
                            ? _c(
                                "a",
                                {
                                  staticClass: "search-changed",
                                  attrs: {
                                    href: "/search/?q=" + _vm.found.altQuery,
                                  },
                                },
                                [
                                  _vm._v(
                                    'Исправлена\n              раскладка клавиатуры. Возможно вы искали "'
                                  ),
                                  _c("span", [
                                    _vm._v(_vm._s(_vm.found.altQuery)),
                                  ]),
                                  _vm._v('"?'),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "ul",
                            { staticClass: "search-panel__list" },
                            [
                              _vm._l(_vm.found.elements, function (item) {
                                return _c(
                                  "li",
                                  {
                                    key: item.id,
                                    staticClass: "search-panel__list-item",
                                  },
                                  [
                                    _c(
                                      "a",
                                      {
                                        staticClass: "items-tips__tip",
                                        attrs: { href: item.url },
                                      },
                                      [
                                        _c("img", {
                                          staticClass: "items-tips__image",
                                          attrs: { src: item.picture, alt: "" },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "items-tips__nameAndPriceWrap",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "items-tips__nameWrap",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "items-tips__name",
                                                  },
                                                  [_vm._v(_vm._s(item.title))]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "items-tips__showAllWrap" },
                                [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "/search/?q=" + _vm.stringSearch,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  Все результаты "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            2
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "search-panel__block" }, [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "search-panel__tipsList" },
                          _vm._l(_vm.found.statistics, function (item, index) {
                            return _c("li", { key: index }, [
                              _c(
                                "a",
                                { attrs: { href: "/search/?q=" + item } },
                                [_vm._v(_vm._s(item))]
                              ),
                            ])
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _vm._m(2),
                        _vm._v(" "),
                        _c(
                          "ul",
                          { staticClass: "search-panel__tipsList" },
                          _vm._l(_vm.found.sections, function (item) {
                            return _c("li", { key: item.id }, [
                              _c("a", { attrs: { href: item.url } }, [
                                _vm._v(_vm._s(item.title)),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm._m(3),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "search-panel__btn-mobile js-search-btn-mobile" },
      [
        _c("span", {
          staticClass: "search-panel__btn-mobile-icon icon icon-lupa",
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", { staticClass: "search-panel__title" }, [
      _c("span", [_vm._v("Популярные запросы")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h4", { staticClass: "search-panel__title" }, [
      _c("span", [_vm._v("Раздел")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "search-panel__button",
        attrs: { type: "submit", value: "" },
      },
      [_c("span", { staticClass: "search-panel__button-icon icon icon-lupa" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }